export const locale = {
    lang: "es-ES",
    data: {
        REGISTER_IDENTITY: {
            TITLE: "¡Bienvenido!",
            SUBTITLE: "¡Complete los campos a continuación para comenzar su viaje para convertirse en un Gurú!",

            CREATE: "Guardar",
            CANCEL: "Cancelar",

            REQUIRED: "este campo es requerido.",
            NAME: "Nombre",
            SURNAME: "Apellido",

            USERNAME: {
                REQUIRED: "Se requiere correo electrónico.",
                INVALID: "Debe completar una dirección de correo electrónico válida."
            },

            USERNAME_ALREADY_IN_USER:
                "Email ya registrado en nuestra plataforma. Si no recuerdas tu contraseña, utiliza el '¿Olvidaste tu contraseña?'",
            GENERIC_ERROR:
                "Error al crear el usuario. Vuelva a intentarlo más tarde o póngase en contacto con nuestro soporte"
        }
    }
};
